import {displayPath} from 'registry/field/FieldPathUtil';
import {SchemaFieldEdge} from 'schemas/fields/SchemaFieldConstants';

export function pathWithoutParentLinkEdges(path: Array<SchemaFieldEdge>): Array<SchemaFieldEdge> {
  // We know that any available paths for entity lineage enforcement will start and end with the parent link
  // fields, which we do not want to include in any of the visual representations of the path that are shown
  // to the user.
  return path.filter((edge, i) => i > 0 && i < path.length - 1);
}

export function getSourceParentSchema(path: Array<SchemaFieldEdge>): {name: string; id: string} {
  // For entity lineage paths specifically, we know that the first edge is a parent link field pointing to
  // the source parent schema
  return path[0].to!;
}

export function getTargetParentSchema(path: Array<SchemaFieldEdge>): {name: string; id: string} {
  // For entity lineage paths specifically, we know that the last edge is a parent link field pointing to
  // the target parent schema
  return path[path.length - 1].to!;
}

export function displayParentLineagePath({
  path,
  includeFields = false,
}: {
  path: Array<SchemaFieldEdge>;
  includeFields?: boolean;
}): string {
  const sourceSchema = getSourceParentSchema(path);
  const pathToDisplay = pathWithoutParentLinkEdges(path);
  return displayPath({sourceTagSchemaId: sourceSchema.id, tagSchemaFieldEdges: pathToDisplay, includeFields});
}
